export default "__VITE_ASSET__CahB208O__"